import { LockOpenPlusIcon } from './LockOpenPlusIcon';

/**
 * author: Colton Wiscombe
 * id 8062D7E8-C9C1-42E1-B42F-E5A9618F1DCD
 * name lock-open-plus
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-plus.svg
 * tags
 * - Lock 
 */
export const LockOpenAddIcon = LockOpenPlusIcon;
export default LockOpenAddIcon